module.exports = __webpack_public_path__ + "static/media/128.450f3b05.jpg";